const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAffiliatorLeadFailures = async (page = 1, perPage = 15, signal = undefined) => {
    const token = localStorage.getItem('token');

    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    const response = await fetch(
        `${API_BASE_URL}/admin/lead/affiliator-failures?page=${page}&per_page=${perPage}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
            },
            signal,
        }
    );
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(result?.message || 'Не удалось загрузить ошибки лидов.');
    }

    return {
        data: Array.isArray(result?.data) ? result.data : [],
        meta: {
            current_page: result?.meta?.current_page || page,
            last_page: result?.meta?.last_page || 1,
            per_page: result?.meta?.per_page || perPage,
            total: result?.meta?.total || 0,
        },
    };
};
